import React, { useState } from 'react';
import { useWallet } from '../hooks/useWallet';

export default function Bridge() {
  const { address } = useWallet();
  const [direction, setDirection] = useState('in');
  const [token, setToken] = useState('OSMO');
  const [amount, setAmount] = useState('');

  const tokens = ['OSMO', 'ATOM', 'USDC'];

  return (
    <div className="page-content fade-up" style={{ maxWidth: 560 }}>
      <div className="card" style={{ marginBottom: 16 }}>
        <div className="card-title" style={{ marginBottom: 20 }}>IBC Bridge</div>

        {/* Direction toggle */}
        <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
          <button
            className={`btn btn-sm ${direction === 'in' ? 'btn-primary' : 'btn-outline'}`}
            style={{ flex: 1 }}
            onClick={() => setDirection('in')}
          >
            ↓ Into Amitis
          </button>
          <button
            className={`btn btn-sm ${direction === 'out' ? 'btn-primary' : 'btn-outline'}`}
            style={{ flex: 1 }}
            onClick={() => setDirection('out')}
          >
            ↑ Out of Amitis
          </button>
        </div>

        {/* Route */}
        <div style={{
          display: 'flex',
          alignItems: 'center',
          gap: 10,
          padding: '14px 16px',
          background: 'var(--off-black)',
          border: '1px solid var(--border)',
          borderRadius: 12,
          marginBottom: 16,
          fontFamily: 'DM Mono, monospace',
          fontSize: 12,
        }}>
          <span style={{ color: direction === 'in' ? 'var(--muted)' : 'var(--green)' }}>
            {direction === 'in' ? 'Osmosis' : 'Amitis Network'}
          </span>
          <span style={{ flex: 1, borderTop: '1px solid var(--border)' }}></span>
          <span style={{ color: 'var(--dimmer)', fontSize: 10 }}>IBC Channel</span>
          <span style={{ flex: 1, borderTop: '1px solid var(--border)' }}></span>
          <span style={{ color: direction === 'in' ? 'var(--green)' : 'var(--muted)' }}>
            {direction === 'in' ? 'Amitis Network' : 'Osmosis'}
          </span>
        </div>

        {/* Token select */}
        <div className="input-group">
          <label className="input-label">Token</label>
          <div style={{ display: 'flex', gap: 8 }}>
            {tokens.map(t => (
              <button
                key={t}
                className={`btn btn-sm ${token === t ? 'btn-primary' : 'btn-outline'}`}
                onClick={() => setToken(t)}
              >
                {t}
              </button>
            ))}
          </div>
        </div>

        <div className="input-group">
          <label className="input-label">Amount</label>
          <input
            className="input-field"
            type="number"
            placeholder="0.000000"
            value={amount}
            onChange={e => setAmount(e.target.value)}
          />
        </div>

        <div style={{ marginBottom: 16 }}>
          <div className="data-row">
            <span className="data-label">Channel</span>
            <span className="data-value">channel-2 (Osmosis)</span>
          </div>
          <div className="data-row">
            <span className="data-label">Estimated time</span>
            <span className="data-value">~30 seconds</span>
          </div>
          <div className="data-row">
            <span className="data-label">Fee</span>
            <span className="data-value green">IBC relay fee only</span>
          </div>
        </div>

        <button
          className="btn btn-primary btn-full"
          onClick={() => !address ? alert('Connect wallet first') : alert('IBC transfer integration coming soon')}
        >
          {address ? `Bridge ${token}` : 'Connect Wallet'}
        </button>
      </div>

      <div className="card">
        <div className="card-title" style={{ marginBottom: 14 }}>About IBC</div>
        <div style={{ fontSize: 13, color: 'var(--muted)', lineHeight: 1.7 }}>
          Inter-Blockchain Communication (IBC) is a trustless protocol for transferring tokens between Cosmos chains.
          Amitis has a live IBC channel to Osmosis. Transfers are atomic, secured by light client verification,
          and require no centralized custodian.
        </div>
      </div>
    </div>
  );
}
